// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"634":"cc117760","644":"1786e4b7"}[chunkId] + ".chunk.js";
};